import Vue from 'vue';

import App from './App.vue';
import store from './store/store';
import router from './router/router';
import i18n from './i18n/i18n';
import vuetify from './plugins/vuetify';
import puiEventsBus from './bus';
import beforeRun from './beforeRun';

import Pui9Login from 'pui9-login';
import Pui9LoginCheckerMixinFactory from 'pui9-login/src/mixins/PuiLoginCheckerMixin';
import Pui9Menu from 'pui9-menu';
import Pui9Notify from 'pui9-notifications';
import Pui9HttpRequests from 'pui9-requests';
import Pui9Datatables from 'pui9-datatables';
import Pui9Components from 'pui9-components';
import Pui9Base from 'pui9-base';
import Pui9Admin from 'pui9-admin';
import Pui9Docgen from 'pui9-docgen';
import Pui9Documents from 'pui9-documents';

import '@fortawesome/fontawesome-pro/css/all.css';
import 'vuetify/dist/vuetify.min.css';

import 'pui9-styles/pui9.css';
import 'pui9-login/dist/pui9-login.css';
import 'pui9-datatables/dist/pui9-datatables.css';
import 'pui9-base/dist/pui9-base.css';
import 'pui9-docgen/dist/pui9-docgen.css';
import 'pui9-documents/dist/pui9-documents.css';

import './styles/app.css';

Vue.config.productionTip = false;

function defineGlobalMixins() {
	Vue.mixin(Pui9LoginCheckerMixinFactory(store, Pui9HttpRequests));
}

function defineGlobalPlugins() {
	Vue.use(Pui9Login);
	Vue.use(Pui9Menu);
	Vue.use(Pui9Notify);
	Vue.use(Pui9Datatables);
	Vue.use(Pui9Components);
	Vue.use(Pui9Base);
	Vue.use(Pui9Admin);
	Vue.use(Pui9Docgen);
	Vue.use(Pui9Documents);

	// Override PUI9 components
	Vue.component('PuiMenuIconBottomBar', () => import('@/components/pui9-override/PuiMenuIconBottomBar'));

	Object.defineProperty(Vue.prototype, '$puiRequests', { value: Pui9HttpRequests });
	Object.defineProperty(Vue.prototype, '$puiEvents', { value: puiEventsBus });
	Object.defineProperty(Vue.prototype, '$puiI18n', { value: i18n });
}

function storeTimezoneHeader() {
	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	store.commit('setHttpRequestHeaders', { timezone });
}

function setLanguage() {
	i18n.locale = window.localStorage.getItem('pui9_lang') || store.state.global.defaultAppLang;
}

(async () => {
	router.beforeEach((to, from, next) => {
		if (to.redirectedFrom && to.redirectedFrom.startsWith('/agros/')) {
			next(to.redirectedFrom.slice(6));
		}
		if (to.path.startsWith('/agros/') && (to.matched.length === 0 || to.matched[0].path === '*')) {
			next(to.path.replace('/agros', ''));
		}

		next();
	});

	router.afterEach((to, from) => {
		if (!to.path.startsWith('/agros/')) {
			window.history.replaceState({}, null, `#/agros${to.fullPath}`);
		}
	});

	puiEventsBus.$on('onPuiChangedLang', lang => {
		i18n.locale = lang;
	});

	Pui9HttpRequests.setStore(store);

	defineGlobalPlugins();

	storeTimezoneHeader();
	setLanguage();

	await beforeRun();

	const vm = new Vue({
		vuetify,
		store,
		router,
		i18n,
		render: h => h(App)
	});

	defineGlobalMixins();

	store.$app = vm;

	vm.$mount('#app');
})();

// Para que se implementa este código exactamente? porque se juega con la URL?
/*
(async () => {

	puiRouter.beforeEach((to, from, next) => {
		if (to.path.startsWith('/agros/') && (to.matched.length === 0 || to.matched[0].path === '*')) {
			return next(to.path.replace('/agros', ''));
		}
		const requiresAuth = to.matched.some(route => route.meta.requiresAuth);
		const session = puiStore.state.session;
		if ((!session || !session.token) && requiresAuth) {
			return next({
				path: `/login`,
				replace: true,
				query: {
					redirect: to.path
				}
			});
		}

		next();
	});

	puiRouter.afterEach(to => {
		if (!to.path.startsWith('/agros/')) {
			history.replaceState({}, null, `#/agros${to.fullPath}`);
		}
	});
})();

*/
